/**
 * reCAPTCHA v3 (invisible, score-based) — no hay checkbox ni UI de usuario.
 * Carga el script de Google una sola vez y expone una función para obtener
 * un token de verificación.
 *
 * Nota: hoy el token generado NO se envía al backend para validación server-side
 * (el flujo de registro solo lo usa como bandera local para habilitar el botón
 * "Continue"). Si en el futuro se requiere protección real contra bots, el
 * token debe reenviarse al backend para verificarlo contra la API de Google
 * (siteverify) usando la secret key, del lado del servidor.
 */

let scriptLoadingPromise = null;

const loadRecaptchaScript = (siteKey) => {
    if (window.grecaptcha) return Promise.resolve();
    if (scriptLoadingPromise) return scriptLoadingPromise;

    scriptLoadingPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('No se pudo cargar el script de reCAPTCHA'));
        document.head.appendChild(script);
    });

    return scriptLoadingPromise;
};

/**
 * Carga el script (si hace falta) y devuelve un token de reCAPTCHA v3.
 * @param {string} siteKey - Site key de reCAPTCHA v3.
 * @param {string} action - Nombre de la acción (para el análisis de score en Google).
 * @returns {Promise<string>} token
 */
export const getRecaptchaV3Token = async (siteKey, action = 'registration') => {
    await loadRecaptchaScript(siteKey);
    return new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(siteKey, { action })
                .then(resolve)
                .catch(reject);
        });
    });
};
